var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLearningStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z",
    fill: "#EEF2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.28 17.2813C24.3993 17.2287 24.5006 17.1422 24.5713 17.0325C24.6419 16.9229 24.6789 16.7949 24.6775 16.6645C24.6762 16.5341 24.6366 16.4069 24.5637 16.2987C24.4908 16.1906 24.3877 16.1062 24.2673 16.056L18.5533 13.4533C18.3796 13.3741 18.1909 13.3331 18 13.3331C17.8091 13.3331 17.6204 13.3741 17.4467 13.4533L11.7333 16.0533C11.6146 16.1053 11.5137 16.1908 11.4428 16.2992C11.3719 16.4077 11.3341 16.5344 11.3341 16.664C11.3341 16.7936 11.3719 16.9203 11.4428 17.0288C11.5137 17.1372 11.6146 17.2227 11.7333 17.2747L17.4467 19.88C17.6204 19.9592 17.8091 20.0002 18 20.0002C18.1909 20.0002 18.3796 19.9592 18.5533 19.88L24.28 17.2813Z",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 16.6667V20.6667",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.3333V20.6667C14 21.1971 14.4214 21.7058 15.1716 22.0809C15.9217 22.456 16.9391 22.6667 18 22.6667C19.0609 22.6667 20.0783 22.456 20.8284 22.0809C21.5786 21.7058 22 21.1971 22 20.6667V18.3333",
    stroke: "#4F39F6",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLearningStatus);
export default __webpack_public_path__ + "static/media/ic_learning_status.9b9a445a40b159f1c522cafc55f35617.svg";
export { ForwardRef as ReactComponent };